export default [
    '$rootScope',
    'SPClientData',
    function eventDataFacade($rootScope, SPClientData) {
        $rootScope.eventData = SPClientData.getInitialEventData();
    }
];
